import $ from 'jquery';
import ProductOptions from './ProductOptions';

export default class VariantHelper {
  constructor(product, $variants, $options) {
    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.productOptions = new ProductOptions(this.product);
    this.optionsTypes = {
      select: 'select',
      radio: 'input[type="radio"]',
    };

    this._bindEvents();

    if (this.$options.is(this.optionsTypes.select)) {
      this.optionsType = this.optionsTypes.select;
    } else if (this.$options.is(this.optionsTypes.radio)) {
      this.optionsType = this.optionsTypes.radio;
    } else {
      console.warn('Variant helper: Option set is not a valid type');
      this._unbindEvents();
    }

    this._switchVariant(true);
  }

  _bindEvents() {
    this.$options.on('change.variant-helper', () => this._switchVariant());
  }

  _unbindEvents() {
    this.$options.off('change.variant-helper');
  }

  _switchVariant(firstLoad = false) {
    const options = [];
    let variant = null;
    let availableOptions = null;

    if (this.optionsType === this.optionsTypes.select) {
      this.$options.each((index, option) => {
        options.push(option.value);
      });
    } else if (this.optionsType === this.optionsTypes.radio) {
      this.$options.filter(':checked').each((index, option) => {
        options.push(option.value);
      });
    } else {
      return;
    }

    variant = this.productOptions.getVariantOrClosestFromOptions(options);

    if (variant) {
      availableOptions = this.productOptions.getAvailableOptionsFromVariant(variant);
    } else {
      return;
    }

    if (this.optionsType === this.optionsTypes.select) {
      this._switchVariantSelect(variant, availableOptions);
    } else if (this.optionsType === this.optionsTypes.radio) {
      this._switchVariantRadio(variant, availableOptions);
    } else {
      return;
    }

    this.$variants.val(variant.id);
    $(window).trigger('product-variant-switch', {variant, firstLoad});
  }

  _switchVariantSelect(variant, availableOptions) {
    // Iterate over each option type
    for (let i = 0; i < this.product.options.length; i++) {
      // Corresponding select dropdown
      const $select = $(this.$options[i]);
      const $optionEls = $select.find('option');

      // Iterate over each option on dropdown
      $optionEls.each((index, option) => {
        const $option = $(option);
        const value = option.value;

        // Not an available option
        $option
          .prop('disabled', availableOptions[i].indexOf(value) === -1)
          .prop('selected', false);

        // Dropdown option matches variant option
        if (variant.options[i] === value) {
          $option
            .prop('disabled', false)
            .prop('selected', true);
        }
      });
    }
  }

  _switchVariantRadio(variant, availableOptions) {
    this.$options
      .attr('disabled', true)
      .prop('checked', false);

    for (let i = 0; i < this.product.options.length; i++) {
      const $options = this.$options.filter(`[name="${ this.product.options[i] }"]`);
      $options.each((index, option) => {
        const $option = $(option);

        if (variant.options[i] === $option.val()) {
          $option
            .prop('checked', true)
            .attr('disabled', false);
        }

        if (availableOptions[i].indexOf($option.val()) !== -1) {
          $option.attr('disabled', false);
        }
      });
    }
  }

  isDefault() {
    if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
      return true;
    }
  }

  hasSingleOption() {
    return this.optionsCount === 1;
  }

  getSelectedVariant() {
    if (this.isDefault()) {
      return this.product.variants[0];
    }

    // Read selected options from the product form
    const options = [];

    if (this.optionsType === this.optionsTypes.select) {
      this.$options.each((index, option) => {
        options.push(option.value);
      });
    } else if (this.optionsType === this.optionsTypes.radio) {
      this.$options.filter(':checked').each((index, option) => {
        options.push(option.value);
      });
    } else {
      return;
    }

    return this.productOptions.getVariantFromOptions(options);
  }

  unload() {
    this._unbindEvents();
  }
}
